import { Delivery } from '@onepercentio/rarum-types/deliveries/model'
import { auth, firestore } from '..'
import { DELIVERIES_PATH } from '../service'
import { splitToChunks } from 'core/helpers/arrays'
import {
  and,
  collection,
  getDocs,
  or,
  query,
  where,
  documentId,
} from '@firebase/firestore'

export async function getDeliveriesById(
  deliveryIds: Delivery['id'][]
): Promise<Delivery[]> {
  const idChunks = splitToChunks(deliveryIds)
  return await Promise.all(
    idChunks.map((chunk) => {
      return getDocs(
        query(
          collection(firestore, DELIVERIES_PATH),
          and(
            where(documentId(), 'in', chunk),
            or(
              where('user.id', '==', auth.currentUser!.uid),
              where('sellOrder.sellerId', '==', auth.currentUser!.uid)
            )
          )
        )
      ).then((docs) => {
        return docs.docs.map((d) => ({ ...d.data(), id: d.id } as Delivery))
      })
    })
  ).then((d) => {
    return d.reduce((acc, r) => [...acc, ...r], [] as Delivery[])
  })
}
